export interface IPhotoCategory {
  id: number;
  categoryId?: number;
  name: string;
  description: string;
  isDefault: boolean;
  createdBy: string;
  createdOn: string;
}

export interface IAssignedPhotoCategory {
  photoCategory: IPhotoCategory;
  assigned: boolean;
}
